import { useSelector } from 'react-redux';
import { getIsInkWidgetOpen } from 'b2b-apps/shop/catalog/redux/inkFinder/selectors';
import { IsInkWidgetOpenType } from 'b2b-apps/shop/catalog/redux/inkFinder/types';

export function useIsInkWidgetOpenData(): IsInkWidgetOpenType {
  return useSelector(getIsInkWidgetOpen);
}
